const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const SelectOptionModal = require("./SelectOptionModal");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const CopyTable = require("../data/CopyTable");

const styles = require("./styles/CancelSubscriptionModal.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "CancelSubscriptionModal",

		propTypes: {
			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			cancelSubscriptionSuccess: function(
				displayName,
				subscriptionID,
				planType,
				usedB2BBulkCode,
				refundBooks,
				refundOnline
			) {
				const options = CopyTable.getCancelSuccessOptionsCopy(styles, planType);
				const other = _.find(options, opt => opt.key === "other");
				let randomOpts = _.filter(options, opt => opt.key !== "other");
				_.each(randomOpts, opt => {
					opt.sort = Math.random();
				});
				randomOpts = _.sortBy(randomOpts, ["sort"]);
				_.each(randomOpts, opt => delete opt.sort);
				randomOpts.push(other);

				this.setState({
					isOpen: true,
					extraInfo: {
						displayName,
						subscriptionID,
						planType,
						usedB2BBulkCode,
						refundBooks,
						refundOnline,
					},
					step: "input",
					options: randomOpts,
				});
			},
			cancelReasonSuccess: function() {
				this.setState({
					step: "confirm",
				});
			},
			cancelReasonFail: function() {
				// If fail, just close the window, they already cancelled.
				this.setState({isOpen: false});
			},
		},

		getInitialState: function() {
			return {
				isOpen: false,
				step: "input", //input, pending, confirm
				options: [],
			};
		},

		onClose: function() {
			this.setState({isOpen: false});
		},

		render: function() {
			const {isOpen, step, extraInfo = {}} = this.state;
			if (isOpen) {
				const copy = CopyTable.getCancelSuccessCopy(
					styles,
					extraInfo.displayName,
					extraInfo.planType,
					extraInfo.usedB2BBulkCode,
					extraInfo.refundBooks,
					extraInfo.refundOnline
				);

				let message,
					options,
					buttonText,
					isLeftAlign,
					textboxLabel,
					textboxNotification;

				const submitInput = selectOptionState => {
					if (this.state.step === "input") {
						const selectedOption = _.find(
							this.state.options,
							o => o.key === selectOptionState.selected
						);
						let reason;
						if (selectedOption) {
							reason = selectedOption.reasonText || selectedOption.label;
						} else if (selectOptionState.textboxContents) {
							reason = "Other.";
						} else {
							// If they haven't entered any text or selected an option
							// just close the survey modal
							this.setState({isOpen: false});
							return;
						}
						if (selectOptionState.textboxContents)
							reason += ` ${selectOptionState.textboxContents}`;
						this.props.dispatch({
							type: AT.SUBMIT_CANCEL_REASON_REQUEST,
							reason,
							subscriptionID: this.state.extraInfo.subscriptionID,
						});

						this.setState({
							step: "pending",
						});
					} else if (this.state.step === "confirm") {
						this.setState({isOpen: false, step: "input"});
					}
				};

				let showAdditionalTextbox = false;
				if (step === "confirm") {
					message = copy.submitted;
					options = [];
					buttonText = "OKAY";
				} else if (step === "pending") {
					message = null;
					options = [];
					buttonText = null;
				} else {
					isLeftAlign = true;
					message = copy.message;
					options = this.state.options;
					buttonText = "SUBMIT";
					textboxLabel = copy.textboxLabel;
					textboxNotification = copy.textboxNotification;
					showAdditionalTextbox = true;
				}

				return (
					<SelectOptionModal
						title={copy.title}
						details={message}
						options={options}
						onSelect={submitInput}
						isLeftAlign={isLeftAlign}
						showAdditionalTextbox={showAdditionalTextbox}
						additionalTextboxLabel={textboxLabel}
						additionalTextboxNotification={textboxNotification}
						buttonText={buttonText}
						onClose={() => this.setState({isOpen: false})}
						hideCancel={true}
						modalSize={"large"}
						textSize={"small"}
						status={this.state.step === "pending" ? "pending" : null}
					/>
				);
			} else {
				return null;
			}
		},
	})
);
